<div
  [ngClass]="{
    'order-entry__panel-more__private-order__container': true,
    'order-entry__panel-more__private-order__container--checked': data.value && !data.locked,
    'order-entry__panel-more__private-order__container--unchecked': !data.value && !data.locked,
    'order-entry__panel-more__private-order__container--locked': data.locked
  }"
>
  <p-checkbox
    class="order-entry__panel-more__private-order__checkbox bfx-checkbox-bold-sm bfx-checkbox-bold-unsized"
    [label]="data.label"
    [binary]="true"
    [disabled]="data.locked"
    [(ngModel)]="data.value"
    (ngModelChange)="onValueChange()"
  >
  </p-checkbox>
</div>
